import { mobileModule } from '@/store/mobile/module'
import { upgradeModule } from '@/store/upgrade/module'
import { referralModule } from '@/store/referral/module'
import { getInitialReferralState } from '@/store/referral/state'
import { router } from '@/router'

const openUpgradeModal = (upgradeContext?: {
    quizMode?: 'weakest' | 'missed'
    upgradePurchasePressed?: boolean
}) => {
    if (upgradeContext) {
        upgradeModule.state.upgradeContext = upgradeContext
    }
    upgradeModule.state.isShowingUpgradeModal = true
}

const closeUpgradeModal = async () => {
    upgradeModule.state.isShowingUpgradeModal = false
    upgradeModule.state.upgradeContext = null

    // If user canceled upgrading after consuming upgrade-specific query params, clear them
    mobileModule.actions.clearUpgradeContextInheritedFromQueryParams()

    // Reset referralModule and remove referral query param for expired coupons
    // Once the user has seen the UpgradeModal with the referral error AND closed it
    const referralError = referralModule.state.referralError
    const isExpiredCouponError =
        referralError?.startsWith('Coupon Expired:')
        && referralError?.endsWith(' is no longer valid.')
    if (isExpiredCouponError) {
        const initial = getInitialReferralState()
        referralModule.state.validReferral = initial.validReferral
        referralModule.state.referralError = initial.referralError
        referralModule.state.hasSeenReferralUpgradePanel = initial.hasSeenReferralUpgradePanel
        const currentRoute = router.currentRoute.value
        if (currentRoute.name && currentRoute.query?.referral) {
            await router.replace({
                name: currentRoute.name,
                query: {
                    ...currentRoute.query,
                    referral: undefined,
                },
            })
        }
    }
}

export default {
    openUpgradeModal,
    closeUpgradeModal,
}
